<template>
  <div id="app">
    <div
      class="shop-header-margin shop-header-element-ui-less"
      :class="'shop-header-element-ui-less-' + data_info.nav_color"
    >
      <div class="top-one">
        <head_dianpu></head_dianpu>
      </div>
      <div class="top-two hidden-sm-and-down">
        <el-row>
          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
            <div>
              <el-row :gutter="20">
                <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7">
                  <img
                    src="../../../assets/home/logo.png"
                    style="width: 100%; height: 100%"
                  />
                </el-col>
                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                  <div class="top-two_text">
                    <span style="float: left">{{ data_info.shop_name }}</span>
                    <div
                      class="follow"
                      style="color: #c60000; border: 1px solid #c60000"
                    >
                      <span v-if="data_info.auth_info.type == 1">个人</span>
                      <span v-if="data_info.auth_info.type == 2">企业</span>
                      <span v-if="data_info.auth_info.type == 3">企业</span>
                    </div>
                    <div
                      class="follow"
                      :class="data_info.nav_color + '_follow'"
                      @click="shouce1()"
                    >
                      {{ xiontai }}
                    </div>
                  </div>
                  <div class="label">
                    技能标签：
                    <el-tag
                      type="info"
                      style="margin-right: 5px"
                      size="mini"
                      v-for="(item, index) in data_info.skill"
                      :key="index"
                      >{{ item.tag_value }}
                    </el-tag>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="20" :md="9" :lg="9" :xl="9">
            <div>
              <el-input
                size="small "
                placeholder="请输入内容"
                v-model="input3"
                class="input-with-select"
              >
                <el-select
                  class="xujz"
                  v-model="select"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-if="data_info.auth_info.type !== 1"
                    label="在线商品"
                  ></el-option>
                  <el-option
                    label="在线服务"
                    value="#/shops/service/"
                  ></el-option>
                  <el-option label="成功案例" value="#/shops/case/"></el-option>
                  <el-option label="仪才秀" value="#/shops/video/"></el-option>
                  <el-option
                    label="小星点灯"
                    value="#/shops/light/"
                  ></el-option>
                  <el-option
                    label="应用方案"
                    value="#/shops/programme/"
                  ></el-option>
                  <el-option
                    label="行业标准"
                    value="#/shops/standard/"
                  ></el-option>
                </el-select>
                <el-button slot="append" @click="shijian">搜索</el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="top-three hidden-sm-and-down" :class="data_info.nav_color">
        <div class="hidden-sm-and-down three_pc">
          <a :href="'#/shops/index/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path === '/shops/index/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              首页
            </div>
          </a>

          <a :href="'#/shops/commodity/' + list.shop_id">
            <el-dropdown
              class="kuai1"
              :class="
                $route.path == '/shops/commodity/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              <span class="el-dropdown-link">在线商品</span>

              <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                <a :href="'#/shops/commodity/' + list.shop_id" style="text-decoration:none">
                  <el-dropdown-item
                   v-for="(shangpin, index) in shangpin_list"
                    :key="index"
                    >{{ shangpin.label }}
                    </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </a>
          <a :href="'#/shops/service/' + list.shop_id">
            <el-dropdown
              class="kuai"
              :class="
                $route.path == '/shops/service/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              <span class="el-dropdown-link">在线服务</span>

              <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                <a :href="'#/shops/service/' + list.shop_id" style="text-decoration:none">
                  <el-dropdown-item
                   v-for="(fuwu, index) in fuwu_list"
                    :key="index"
                    >{{ fuwu.label }}
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </a>
          <a :href="'#/shops/case/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/case/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              成功案例
            </div>
          </a>
          <a :href="'#/shops/video/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/video/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              仪才秀
            </div>
          </a>
          <a :href="'#/shops/light/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/light/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              小星点灯
            </div>
          </a>
          <a :href="'#/shops/programme/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/programme/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              应用方案
            </div>
          </a>
          <a :href="'#/shops/standard/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/standard/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              行业标准
            </div>
          </a>
          <a :href="'#/shops/companyData/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/companyData/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              公司资料
            </div>
          </a>
          <a :href="'#/shops/bidding/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/bidding/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              求购信息
            </div>
          </a>
        </div>
      </div>
      <el-container class="ciyemian_yibei_qiangzhi_buxudong flextext">
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no"
        />
        <el-main>
          <div class="contain">
            <div class="small-title">{{ list.title }}</div>
            <el-row :gutter="30">
              <el-col :xs="24" :sm="24" :md="9">
                <div class="shop_list">
                  <el-image
                    class="shop1"
                    :src="url + '/storage/' + list.cover"
                    fit="cover"
                  >
                    <div slot="error" class="image-slot">
                      <img
                        src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                        alt=""
                        style="height: 460px; width: 460px"
                      />
                    </div>
                  </el-image>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="15">
                <div class="shop-span">
                  <ul style="position: absolute">
                    <li v-if="list.jiaofu == 2">现货</li>
                    <li v-if="list.jiaofu == 3">
                      订货
                      <div class="jiaofu_time">
                        {{ list.jiaofu_date + "天" }}
                      </div>
                    </li>
                  </ul>
                </div>
                <div style="margin-bottom: 30px; margin-left: 40px">
                  <div>
                    <span class="prices" v-if="list.price_yugu == 0.0"
                      >明码标价

                      <span class="moneys">¥</span
                      ><span class="value">{{ list.cash }}</span>
                    </span>
                    <span class="prices" v-else
                      >预估价格 <span class="moneys">¥</span
                      ><span class="value">{{ list.price_yugu }}</span>
                    </span>
                  </div>
                  <div class="guige_tou" v-if="list.attachment[0]">
                    <span style="margin-right: 65px; float: left">附件</span>
                    <a
                      :href="url + '/storage/' + list.attachment[0].url"
                      target="“_blank”"
                      style="display: block; float: left; margin-left: 35px"
                    >
                      <el-link type="primary">{{
                        list.attachment[0].name
                      }}</el-link>
                    </a>

                    <a :href="'#/shops/commodity/' + list.shop_id">
                      <el-dropdown
                        class="kuai1"
                        :class="
                          $route.path == '/shops/commodity/' + list.shop_id
                            ? data_info.nav_color + '_new'
                            : ''
                        "
                      >
                        <span class="el-dropdown-link">在线商品</span>

                        <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                          <el-dropdown-item
                            v-for="(xiang, index) in data_info.goods_cate"
                            :key="index"
                            >{{ xiang.label }}</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </a>
                    <a :href="'#/shops/service/' + list.shop_id">
                      <el-dropdown
                        class="kuai"
                        :class="
                          $route.path == '/shops/service/' + list.shop_id
                            ? data_info.nav_color + '_new'
                            : ''
                        "
                      >
                        <span class="el-dropdown-link">在线服务</span>

                        <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                          <el-dropdown-item
                            v-for="(xiang, index) in data_info.skill"
                            :key="index"
                            >{{ xiang.tag_value }}</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </a>
                  </div>

                  <div class="guige_tou" v-if="list.cert_file[0]">
                    <span style="margin-right: 65px; float: left"
                      >必要资质</span
                    >
                    <a
                      :href="url + '/storage/' + list.cert_file[0].url"
                      style="display: block; float: left"
                      target="“_blank”"
                    >
                      <el-link type="primary">{{
                        list.cert_file[0].name
                      }}</el-link>
                    </a>
                  </div>
                </div>
                <el-divider class="hr"></el-divider>
                <!--规格型号-->
                <span v-if="aa == 1" style="margin-top: 50px; height: auto">
                  <!--                                       <span style="" >规格型号</span>-->
                  <span
                    v-for="(item, index2) in list_guige.slice(0, 3)"
                    :key="index2"
                    class="prices-one"
                  >
                    <span
                      style="margin-left: 135px; width: 100px"
                      class="moneys-num_a"
                    >
                      {{ item.specification }}
                    </span>
                    <span
                      style="width: 100px"
                      class="moneys-num_a"
                      v-if="item.price == '0.00' && item.sum !== 0"
                      >{{ item.estimate * item.sum }}元</span
                    >
                    <span
                      v-if="item.price == '0.00' && item.sum == 0"
                      class="moneys-num_a"
                      style="width: 100px"
                      >{{ item.estimate * 1 }}元</span
                    >
                    <span
                      style="width: 100px"
                      class="moneys-num_a"
                      v-if="item.price !== '0.00' && item.sum !== 0"
                      >{{ item.price * item.sum }}元</span
                    >
                    <span
                      v-if="item.price !== '0.00' && item.sum == 0"
                      class="moneys-num_a"
                      style="width: 100px"
                      >{{ item.price * 1 }}元</span
                    >

                    <span class="jibuqi">
                      <el-input-number
                        size="mini"
                        v-model="item.sum"
                        @change="handleChange2"
                        :min="0"
                        :max="10"
                        label=""
                        class=""
                      ></el-input-number>
                    </span>
                    <el-divider class="hrs"></el-divider>
                    <span
                      v-if="index2 == 0"
                      style="position: relative; left: -560px"
                    >
                      规格描述
                    </span>
                    <span
                      v-if="index2 == 0"
                      style="position: relative; left: -30px"
                    >
                      <i class="el-icon-arrow-down" @click="xiala((aa = 2))"
                        >更多</i
                      ></span
                    >
                  </span>
                </span>
                <!--                                收起-->
                <span v-if="aa == 2">
                  <span
                    class="prices-one_a"
                    v-for="(item, index2) in list_guige"
                    :key="index2"
                  >
                    <span class="moneys-num_a">
                      {{ item.specification }}
                    </span>
                    <span
                      style="width: 100px"
                      class="moneys-num_a"
                      v-if="item.price == '0.00' && item.sum !== 0"
                      >{{ item.estimate * item.sum }}元</span
                    >
                    <span
                      v-if="item.price == '0.00' && item.sum == 0"
                      class="moneys-num_a"
                      style="width: 100px"
                      >{{ item.estimate * 1 }}元</span
                    >
                    <span
                      style="width: 100px"
                      class="moneys-num_a"
                      v-if="item.price !== '0.00' && item.sum !== 0"
                      >{{ item.price * item.sum }}元</span
                    >
                    <span
                      v-if="item.price !== '0.00' && item.sum == 0"
                      class="moneys-num_a"
                      style="width: 100px"
                      >{{ item.price * 1 }}元</span
                    >
                    <span class="jibuqi">
                      <el-input-number
                        size="mini"
                        v-model="item.sum"
                        @change="handleChange2"
                        :min="0"
                        :max="10"
                        label=""
                        class=""
                      ></el-input-number>
                    </span>
                    <el-divider class="hrs"></el-divider>
                    <span
                      v-if="index2 == 0"
                      style="position: relative; left: -560px"
                    >
                      规格描述
                    </span>
                    <span
                      v-if="index2 == 0"
                      style="position: relative; left: -30px"
                    >
                      <i class="el-icon-arrow-up" @click="xiala((aa = 1))"
                        >收起</i
                      ></span
                    >
                  </span>
                </span>

                <!--               <span>-->
                <!--                      <span class="prices-one" v-for="(item,index2) in list_guige" :key="index2">-->
                <!--                               <span style="display: block" >-->

                <!--                               <span class="moneys-num" :style="index2==0?'':'margin-left:135px; width:100px'">-->
                <!--                                {{item.specification}}</span>-->
                <!--                                <span v-if="index2==0" >规格型号</span>-->
                <!--                                    &lt;!&ndash;  <span class="moneys-num"&ndash;&gt;-->
                <!--                                    &lt;!&ndash; style="margin-left:70px; width:150px;overflow:hidden;font-size:14px">{{item.specification}}</span>&ndash;&gt;-->
                <!--                                <span class="moneys-nums" style="width: 100px" v-if="item.price=='0.00'&&item.sum!==0">{{ item.estimate * item.sum }}元</span>-->
                <!--                                <span v-if="item.price=='0.00'&&item.sum==0" class="moneys-nums" style="width: 100px">{{item.estimate * 1}}元</span>-->
                <!--                                <span class="moneys-nums" style="width: 100px" v-if="item.price!=='0.00'&&item.sum!==0">{{ item.price * item.sum }}元</span>-->
                <!--                               <span v-if="item.price!=='0.00'&&item.sum==0" class="moneys-nums" style="width: 100px">{{item.price * 1}}元</span>-->
                <!--                               <span class="jibuqi">-->
                <!--                                      <el-input-number size="mini" v-model="item.sum" @change="handleChange2" :min="0"-->
                <!--                                                       :max="10"-->
                <!--                                                       label="" class=""></el-input-number>-->
                <!--                              </span>-->

                <!--                             <el-divider class="hrs"></el-divider>-->
                <!--                          </span>-->
                <!--                             </span>-->
                <!--                           </span>-->
                <!--按钮立即购买 -->
                <span class="buy">
                  <el-button
                    @click="goumai_sj(list.id)"
                    class="buy-button"
                    type="primary"
                    >立即购买</el-button
                  >
                </span>
                <span class="buy">
                  <el-button
                    class="buy-button"
                    type="primary"
                    v-if="status"
                    @click="shouce(list.id)"
                    >{{ status }}</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <div style="margin-bottom: 40px; height: 400px; width: 100%">
              <div class="aaa hidden-sm-and-down">
                <div class="xinxi">



                  <!-- <el-row :gutter="2" class="lxtop">
                    <el-col class="word-shop" :span="9" :offset="2"
                      >店铺名称：</el-col
                    >
                    <el-col class="word-shop" :span="9">{{
                      inform.shop_name
                    }}</el-col>
                  </el-row>
                  <el-divider class="hengxian"></el-divider>
                  <el-row :gutter="2" class="lxtop">
                    <el-col class="word-shop" :span="9" :offset="2"
                      >用户名:</el-col
                    >
                    <el-col class="word-shop" :span="9">{{
                      inform.name
                    }}</el-col>
                  </el-row>
                  <el-row :gutter="2" class="lxtop">
                    <el-col class="word-shop" :span="9" :offset="2"
                      >联系我:</el-col
                    >
                    <div class="yixiaoxing">
                      <img
                        src="../../../assets/home/yixiaoxing1.png"
                        alt=""
                        class="image"
                        @click="chat_room"
                      />
                    </div>
                  </el-row>
                  <el-row :gutter="2" class="lxtop">
                    <el-col class="word-shop" :span="9" :offset="2"
                      >联系方式:</el-col
                    >
                    <el-col class="word-shop" :span="9">{{
                      inform.mobile
                    }}</el-col>
                  </el-row>
                  <el-row :gutter="2" class="lxtop">
                    <el-col class="word-shops" :span="9" :offset="2">
                      所在区域:</el-col
                    >
                    <el-col class="word-shops" :span="9"
                      >{{ sheng }}{{ shi }}{{ qv }}</el-col
                    >
                  </el-row>
                  <div class="buttons">
                    <button>
                      <a :href="'#/shops/index/' + list.shop_id">进入店铺</a>
                    </button>
                  </div> -->
                  <div class="xinxi" style="width: 230px; height: 272px">
                  <div
                    style="
                      background-color: #4e6ef2;
                      height: 45px;
                      width: 229px;
                      border-radius: 5px 5px 0px 0px;
                    "
                  >
                    <i class="el-icon-service"></i>
                    <span class="kefuzhongxin">客服中心</span>
                  </div>
                  <div>
                    <div class="center_title flex">
                      在线联系
                      <div class="yixiaoxing">
                        <img
                          src="../../../assets/home/yixiaoxing1.png"
                          alt=""
                          class="image"
                          @click="chat_room"
                        />
                      </div>
                    </div>

                    <p class="center_title">联系电话</p>
                    <p class="center_mintitle">{{ inform.mobile }}</p>
                    <p class="center_title">厂家地址</p>
                    <p class="center_mintitle">{{ sheng }}{{ shi }}{{ qv }}</p>
                  </div>
                </div>


                </div>
              </div>
              <div class="bottom_right_background">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="详情描述" name="first">
                    <div class="xiangqing_background1"></div>
                    <div class="xiangqing_background">
                      <div class="xiangqing_title">
                        <span style="float: left; margin-left: 23px">
                          关键指标参数：</span
                        >
                        <span>
                          <el-row
                            v-for="(item, index) in list.key_index.split(',')"
                            v-bind:key="index"
                            style="display: flex"
                          >
                            <el-col v-if="index % 2 == 0" class="title">
                              <block>
                                {{ list.key_index.split(",")[index] }}</block
                              >
                              <block class="title_list">{{
                                list.key_index.split(",")[index + 1]
                              }}</block>
                            </el-col>
                          </el-row>
                        </span>
                      </div>
                      <div class="xiangqing_title">
                        <span style="float: left; margin-left: 90px"
                          >行业领域:</span
                        >
                        <span>
                          <el-row
                            v-for="(item, index) in yingyong_hy.split(',')"
                            v-bind:key="index"
                            style="display: flex"
                          >
                            <el-col v-if="index % 2 == 0" class="title">
                              <block>
                                {{ yingyong_hy.split(",")[index] }}</block
                              >
                              <block class="title_list">
                                {{ yingyong_hy.split(",")[index + 1] }}</block
                              >
                            </el-col>
                          </el-row>
                        </span>
                      </div>
                      <div class="julizhi"></div>
                    </div>
                    <div class="clear"></div>
                    <div class="xiangqing_background1"></div>
                    <div
                      class="bottom_titlemiaoshu imgsize"
                      v-html="list.desc"
                    ></div>
                  </el-tab-pane>
                  <el-tab-pane label="配置方案" name="second">
                    <div class="xiangqing_background1"></div>
                    <div
                      class="bottom_titlemiaoshu"
                      v-html="list.configuration"
                    ></div>
                  </el-tab-pane>
                  <el-tab-pane label="案例解析" name="third">
                    <div class="xiangqing_background1"></div>
                    <a
                      v-if="list.list_cases[0]"
                      v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[0].id
                      "
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_cases[0].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_cases[1]"
                      v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[1].id
                      "
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_cases[1].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_cases[2]"
                      v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[2].id
                      "
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_cases[2].title"
                      ></div>
                    </a>
                  </el-tab-pane>
                  <el-tab-pane label="小星点灯" name="fourth">
                    <div class="xiangqing_background1"></div>
                    <!--                  <div v-if="list.list_light[0]!==''" class="bottom_titlemiaoshu"  v-html="list.list_light[0].title"></div>-->
                    <a
                      v-if="list.list_light[0]"
                      v-bind:href="'#/dianpu_ligs/' + list.list_light[0].id"
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_light[0].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_light[1]"
                      v-bind:href="'#/dianpu_ligs/' + list.list_light[1].id"
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_light[1].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_light[2]"
                      v-bind:href="'#/dianpu_ligs/' + list.list_light[2].id"
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_light[2].title"
                      ></div>
                    </a>
                  </el-tab-pane>
                  <el-tab-pane label="应用方案" name="fifth">
                    <div class="xiangqing_background1"></div>
                    <a
                      v-if="list.list_applicationProgram[0]"
                      v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[0].id
                      "
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_applicationProgram[0].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_applicationProgram[1]"
                      v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[1].id
                      "
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_applicationProgram[1].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_applicationProgram[2]"
                      v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[2].id
                      "
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_applicationProgram[2].title"
                      ></div>
                    </a>
                  </el-tab-pane>
                  <el-tab-pane label="行业标准" name="sixth">
                    <div class="xiangqing_background1"></div>
                    <a
                      v-if="list.list_norm[0]"
                      v-bind:href="'#/college/standard/' + list.list_norm[0].id"
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_norm[0].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_norm[1]"
                      v-bind:href="'#/college/standard/' + list.list_norm[1].id"
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_norm[1].title"
                      ></div>
                    </a>
                    <a
                      v-if="list.list_norm[2]"
                      v-bind:href="'#/college/standard/' + list.list_norm[2].id"
                    >
                      <div
                        style="word-break: break-all"
                        class="bottom_titlemiaoshu"
                        v-html="list.list_norm[2].title"
                      ></div>
                    </a>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </el-main>
        <footerall></footerall>
      </el-container>
    </div>
  </div>
</template>
<script>
// import home_head from '../../common/home-head';
import { CodeToText } from "element-china-area-data";
import footerall from "../../common/footer";
import head from "../../common/head";
// import Block_nav from "../../houtai/common/nav";
// import Block_nav from "../../houtai/common/nav";
export default {
  name: "category",
  data: function () {
    return {
      favorite: false,
      is_open: {
        sousuo: 1,
        lanmu: 1,
      },
      dat_info: "",
      value: 5,
      status: "",
      aa: 1,
      activeName: "first",
      list: "",
      input3: "",
      list_guige: [],
      // yingyong_hy : [],
      url: "",
      select: "在线服务",
      data_info: "",
      num: ["", "", ""],
      information: "",
      shop_id:"",
      inform: "",
      sheng: "",
      shi: "",
      qv: "",
      anli: [],
      diandeng: [],
      fangan: [],
      biaozhun: [],
      yingyong_hy: [],
      xiontai: "",
      config: {
        email: "",
        phone: "",
      },
      data_list: [],
      data_uid: "",
      list_uid: "",
      inform_uid: "",
      inform_name: "",
      shangpin_list:'',
      fuwu_list:''
    };
  },
  components: {
    // 'home-head': home_head,
    head_dianpu: head,
    footerall,
  },
  methods: {
    // 导航
    Changeshuju() {
      this.$store.commit("Changestate");
    },
    xiala(aa) {
      console.log(aa);
    },
    getConfig: function () {
      var t = this;
      // this.config.email = localStorage.getItem('site:email');
      // this.config.phone = localStorage.getItem('site:service-phone');
      if (!this.config.email || !this.config.phone) {
        let url = window.config.api_url + "/user/config/site";
        this.axios.get(url).then((res) => {
          t.config.email = res.data.site.email;
          t.config.phone = res.data.site["service-phone"];
          // localStorage.setItem('site:email', t.config.email);
          // localStorage.setItem('site:service-phone', t.config.phone);
        });
      }
    },
    guanzhu() {
      var t = this;
      var id = localStorage.getItem("token");
      var url =
        window.config.api_url +
        "/user/shop/focus/check/" +
        t.$route.params.id +
        "?token=" +
        id;
      t.axios.get(url).then((res) => {
        // console.log(res,89444444444)
        t.xiontai = res.data.focus == 1 ? "已关注" : "关注";
      });
    },
    shouce1() {
      // console.log(cet);
      var t = this;
      var id = localStorage.getItem("uid");
      var formData = new FormData();
      formData.append("token", id);
      formData.append("shop_id", this.$route.params.id);
      if (t.xiontai == "关注") {
        var url = window.config.api_url + "/user/shop/focus";
        t.axios.post(url, formData).then((res) => {
          // console.log(res)
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            // t.list_data()
            this.$router.go(0);
          }
          if (res.data.status != 0) {
            t.open3(res.data.description);
          }
        });
        this.xiontai = "已关注";
      } else {
        var url1 = window.config.api_url + "/user/shop/unfocus";
        t.axios.post(url1, formData).then((res) => {
          // console.log(res)
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            // t.list_data()
            this.$router.go(0);
          }
          if (res.data.status != 0) {
            t.open3(res.data.description);
          }
        });
        this.xiontai = "关注";
      }
    },
    shijian() {
      var t = this;
      if (t.input3) {
        t.$store.commit("shopsSearchValue", t.input3);
      }
      window.location = t.select + this.list.shop_id;
    },

    sousuo_xuanxiang(e) {
      this.is_open.sousuo = e;
      console.log(this.is_open.sousuo);
    },
    init() {
      this.get_uidlist();
      this.information = this.$store.state.information;
      this.url = window.config.api_url;

      console.log(window.config.api_url);
      this.list_data();
      this.zhuangtai();
      this.guanzhu();
      this.getConfig();
      // this.dp_inform()
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    zhuangtai() {
      var t = this;
      var id = localStorage.getItem("token");
      var url =
        window.config.api_url +
        "/user/goods/focus/check/" +
        t.$route.params.id +
        "?token=" +
        id;
      t.axios.get(url).then((res) => {
        t.status = res.data.focus;
        // console.log(res,89444444444)
        // t.status = res.data.focus == 0 ? '收藏商品' : '已收藏'
        t.status = res.data.focus == 1 ? "已收藏" : "收藏商品";
      });
    },
    shouce() {
      // console.log(cet);
      var t = this;
      var id = localStorage.getItem("uid");
      var formData = new FormData();
      formData.append("token", id);
      formData.append("goods_id", this.$route.params.id);
      if (t.status == "收藏商品") {
        var url = window.config.api_url + "/user/goods/focus";
        t.axios.post(url, formData).then((res) => {
          console.log(res);
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            // 接口调用成功
            this.$router.go(0);
          }
        });
        this.status = "已收藏";
      } else {
        var url1 = window.config.api_url + "/user/goods/unfocus";
        t.axios.post(url1, formData).then((res) => {
          // console.log(res)
          t.$code(res.data.status);
          if (res.data.status == 0) {
            // 接口调用成功
            t.open2("成功");
            // this.status = '收藏商品'// 要改成的值
            this.$router.go(0);
          }
        });
        this.status = "收藏商品";
      }
    },
    dp_inform() {
      var t = this;
      var url =
        window.config.api_url + "/college/shop/info?id=" + t.list.shop_id;
      t.axios.get(url).then((res) => {
        t.inform = res.data;
        t.inform_uid = res.data.uid;
        t.inform_name = res.data.name;
        // t.dzhi = res.data.id;
        t.data_info = res.data;
        CodeToText[res.data.auth_info.province] === undefined
          ? (t.sheng = res.data.auth_info.province_name)
          : (t.sheng = CodeToText[res.data.auth_info.province]);
        CodeToText[res.data.auth_info.city] === undefined
          ? (t.shi = res.data.auth_info.city_name)
          : (t.shi = CodeToText[res.data.auth_info.city]);
        CodeToText[res.data.auth_info.area] === undefined
          ? (t.qv = res.data.auth_info.area_name)
          : (t.qv = CodeToText[res.data.auth_info.area]);
        // t.sheng = CodeToText[res.data.auth_info.province];
        // t.shi = CodeToText[res.data.auth_info.city];
        // t.qv = CodeToText[res.data.auth_info.area];
      });
    },
    goumai_sj(e) {
      var t = this;
      var list_vu = [];
      t.list_guige.forEach(function (item) {
        if (item.sum !== 0) {
          list_vu.push({
            estimate: item.estimate,
            goods_id: item.goods_id,
            id: item.id,
            price: item.price,
            specification: item.specification,
            sum: item.sum,
          });
        }
      });
      if (list_vu == "") {
        return t.$message.error("请至少选择一个商品规格");
      }
      t.$store.commit("saveDbSource", list_vu);
      window.location = "#/purchase/" + e;
    },
    chat_room() {
      if (this.data_uid != "") {
        window.location.href =
          "#/chat_new/" + this.data_uid + "?uid=" + this.inform_uid;
      } else {
        window.location.href = "/user.html";
      }
    },
    list_data() {
      var t = this;
      var url = window.config.api_url + "/college/goods/" + t.$route.params.id;
      t.axios.get(url).then((res) => {
        t.list = res.data;
        t.shop_id = res.data.shop_id;
        t.list_uid = res.data.uid;
        

        for (let i = 0; i < t.list.aac.length; i++) {
          t.yingyong_hy.push(t.list.aac[i].title);
        }
        t.yingyong_hy = t.yingyong_hy.join(",");
        res.data.specification.forEach(function (item) {
          t.list_guige.push({
            estimate: item.estimate,
            goods_id: item.goods_id,
            id: item.id,
            price: item.price,
            specification: item.specification,
            sum: 0,
          });
        });
        t.dp_inform();
        t.shangpin_data();
        t.fuwu_data();
      });
    },
    fujiaxz(e) {
      this.$router.push(this.url + "/storage/" + e);
    },
    handleChange2(e) {
      this.$store.commit("savePath", e);
    },
    get_uidlist() {
      var t = this;
      var aid = localStorage.getItem("uid");
      var url = window.config.api_url + "/user/shop/info?token=" + aid;
      t.axios.get(url).then((res) => {
        t.data_list = res.data;
        t.data_uid = res.data.shop_info.uid;
        
      });

    },
    shangpin_data(){
      var t = this
      var url = window.config.api_url+'/college/shop/goods/cate?shop_id='+t.shop_id;
      t.axios.get(url).then(res=>{
        if (res.data.status){
          t.$code(res.data.status)
        }
        if (res.data.status==401){
          t.opent()
        }
        t.shangpin_list = res.data
          console.log("sangpin_list",res.data)
        // t.zongshu = res.data.goods_list.total
        // t.yemashu =  res.data.goods_list.last_page
        // console.log(res)
      })
    },
    fuwu_data(){
      var t = this
      var url = window.config.api_url+'/college/shop/fuwu/cate?shop_id='+t.shop_id;
      t.axios.get(url).then(res=>{
        if (res.data.status){
          t.$code(res.data.status)
        }
        if (res.data.status==401){
          t.opent()
        }
        t.fuwu_list = res.data
          console.log("fuwu_list",res.data)
        // t.zongshu = res.data.goods_list.total
        // t.yemashu =  res.data.goods_list.last_page
        // console.log(res)
      })
    },
  },

  created() {
    this.init();
    this.list_data()
    
    
  },
  beforeRouteEnter(to, from, next) {
    console.log("to122", to, from);
    next();
  },
};
</script>
<style lang="less">
.home_shop_xiang_peizhi_qiangzhi_elementui_leixing {
  .el-tabs__nav-wrap::after {
    background-color: #ffffff !important;
    width: 0;
  }
}
</style>


<style>
.julizhi {
  margin-top: 10px;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__active-bar {
  background-color: #4e6ef2;
  left: 1px;
  width: 58px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-left:before {
  display: none !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-right:before {
  display: none !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
  /*padding: 0 14px!important;*/
  /*font-size: 14px!important;*/
  line-height: 47px;
  font-size: 18px !important;
  padding-right: 83px !important;
  /*margin-right: 88px;*/
  /*padding: 0 44px!important;*/
  height: 45px;
  font-weight: bold;
  color: #333333;
}

.el-tabs__nav-scroll {
  margin-left: 45px;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__item {
  padding: 0 !important;
  width: 120px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tab-pane {
  margin-left: 35px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom[data-v-7edfb125] {
  left: -10px;
}

@media screen and (min-width: 995px) and (max-width: 1500px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 25px !important;
    /*margin-right: 26px;*/
    font-size: 15px !important;
    /*padding-left: 25px;*/
    height: 45px;
    font-weight: bold;
    color: #333333;
  }
}

@media screen and (min-width: 750px) and (max-width: 995px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 24px !important;
    font-size: 16px !important;
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 0px !important;
    margin-top: 25px;
  }
}

@media screen and (max-width: 750px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .contain {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .moneys-num {
    margin-left: 55px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .moneys-nums {
    margin-left: 45px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 4px !important;
    font-size: 13px !important;
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 0px !important;
    margin-top: 25px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi {
    margin-left: 50px !important;
  }
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__header {
  margin-bottom: 0px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom div {
  margin-left: 23px;
  margin-right: 40px !important;
  float: left;
  font-size: 14px;
  color: #666666;
  line-height: 60px;
}

.jibuqi {
  margin-left: 68px;
}

.jibuqi .el-input__inner {
  padding: 0;
  border: 0px;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-minus:before {
  font-size: 14px !important;
  color: #ffffff;
  font-weight: bold;
  content: "\e6d8";
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-plus:before {
  font-size: 14px !important;
  color: #ffffff;
  font-weight: bold;
  content: "\e6d9";
}

.jibuqi .el-input-number--mini {
  width: 98px;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__increase {
  width: 27px;
  background: #4e6ef2 !important;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__decrease {
  width: 27px;
  background: #4e6ef2 !important;
}

.imgsize p img {
  max-width: 100%;
}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

@head_text: Source Han Sans CN;

@import "../../../assets/css/home";
@import "../../../assets/css/home_details";
@import "../../../assets/css/head_yangshi";
//@import "../../../assets/css/goods_detailed";
.flextext {
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
}

.btncss {
  position: absolute;
}
.yixiaoxing {
  // margin-top: 20px;
  //   margin-left: 20px;
  height: 25px;
  width: 25px;
  // background-color: #ccc;
  display: inline-block;
  //   position: absolute;
  //   top: 6px;
  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>